export const styles = {
  wrap: {
    padding: '0 20px',
    marginRight: 80,
    backgroundColor: '#F9F9FF',
  },
  controlsWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  modalContainer: {
    width: 800,
  },
  headerContainer: {
    width: '100%',
    padding: '20px 0',
  },
  tabsContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 30,
    justifyContent: 'space-between',
  },
  createChatButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'flex-end',
  },
  header: {
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  headerTitle: {
    fontSize: 32,
    color: 'black',
    fontWeight: '800',
    fontFamily: "'Proxima Nova', sans-serif",
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 14,
    marginTop: 24,
  },
  checkbox: {
    marginRight: 10,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  checkboxLabel: {
    fontSize: 16,
    color: '#011533',
    fontFamily: "'Proxima Nova', sans-serif",
  },
}
